<template>
  <a-layout class="introduction">
    <a-layout-header class="layout-header">
			<div class="v-goside" :class="{'v-goside-in':onout}" @mouseenter="openOutSide(true)" @mouseleave="openOutSide(false)">
				<a-icon type="bars" />
			</div>
      <div class="brand"><span>Dr.COM Billingware V6</span></div>
      <user-info :style="{ position: 'relative', float: 'right'}" @nav-change="navChange"/>
      <nav-menu :iframe="iframe" :products="products" @nav-change="navChange" @nav-index="navIndex"/>
    </a-layout-header>
    <a-layout-content>
      <dr-index v-show="showIndex" :products="products" @nav-change="navChange" style="margin-top: 50px"/>
      <div class="iframe-set-warpper" v-show="!showIndex" v-if="iframe != null && iframe.href != null">
        <dr-iframe-set ref="iframeSet" :iframe="iframe"/>
      </div>
    </a-layout-content>
		<out-side :products="products" @nav-change="navChange" @nav-index="navIndex" @out-side="openOutSide" :onout="onout" />
  </a-layout>
</template>
<script>
import { getProducts } from '@/api/v1'
import UserInfo from '_c/UserInfo'
import NavMenu from '_c/NavMenu'
import DrIndex from '_c/DrIndex'
import DrIframeSet from '_c/IframeSet'
import OutSide from '_c/OutSide'

export default {
  name: 'Layout',
  components: {
    UserInfo, NavMenu, DrIndex, DrIframeSet, OutSide
  },
  mounted () {
    getProducts().then(response => {
      if (response && response.data) {
        this.products = response.data
  
        let hash = window.location.hash
        if (hash != null && hash.length > 1) {
          let view = this.$_.find(this.products, ['name', hash.substring(1)])
          if (view != null) {
            this.navChange(view);
          }
        }
      }
    }).catch(err => {
      this.$message.error(err.toString())
    });
  },
  methods: {
    navIndex() {
      this.showIndex = true;
      this.iframe = Object.assign({});
    },
    navChange(view) {
      this.showIndex = false;
      this.iframe = Object.assign(view);
    },
		openOutSide(flag, time=260) {
			clearTimeout(this.timer1);
			this.timer1=setTimeout(() => {
				this.onout = flag;
			}, time);
		}
  },
  data() {
    return {
      products: [],
      iframe: {},
      showIndex: true,
			onout: false
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import './index.scss';
</style>
